import ChallengeService from '../../services/challenge.service'
import ConfirmService from '../../services/confirm.service'
import ToastService from '../../services/toast.service'
import {
	SET_CHALLENGE_SPACE_CHALLENGES,
	UPDATE_CHALLENGE_SPACE_CHALLENGES,
	SET_ACCOUNT_CHALLENGE,
	REMOVE_CHALLENGE_SPACE_CHALLENGE,
	UPDATE_CHALLENGE_SPACE_CHALLENGE,
	SET_ACCOUNT_CHALLENGES,
	UPDATE_ACCOUNT_CHALLENGE,
	UPDATE_ACCOUNT_CHALLENGE_USERS,
	SET_ACCOUNT_CHALLENGE_NOTE,
	REMOVE_ACCOUNT_CHALLENGE,
	FILTER_ACCOUNT_CHALLENGES,
	SET_CHALLENGE_TEAMS,
	UPDATE_CHALLENGE_TEAMS,
	UPDATE_CHALLENGE_SPACE_CHALLENGE_USERS,
	REMOVE_AUTH_CHALLENGE,
	UPDATE_SELECTED_CHALLENGE_USERS,
} from './'

const createChallenge = (payload: any) => {
	return async () => {
		const result = await ChallengeService.createChallenge(payload)
		return result
	}
}

const deleteChallenge = (payload: { challengeId: string }) => {
	return async (dispatch: any) => {
		return await ConfirmService.confirm({
			title: 'Are you sure you want to delete this challenge?',
		}).then((result) => {
			if (result.value) {
				return ChallengeService.deleteChallenge(payload.challengeId)
					.then((respone) => {
						if (respone) {
							dispatch({
								type: REMOVE_CHALLENGE_SPACE_CHALLENGE,
								response: { challengeId: payload.challengeId },
							})

							ToastService.showSuccess('Challenge deleted')

							return true
						}
						return false
					})
					.catch(() => {
						ToastService.showError(
							'Failed to delete challenge. This challenge is already involved in a ranking or matching'
						)
						return false
					})
			} else {
				return false
			}
		})
	}
}

const deleteAccountChallenge = (payload: { challengeId: string }) => {
	return async (dispatch: any) => {
		await ConfirmService.confirm({
			title: 'Are you sure you want to delete this challenge?',
		}).then((result) => {
			if (result.value) {
				return ChallengeService.deleteChallenge(payload.challengeId).then(
					(response) => {
						if (response) {
							dispatch({
								type: REMOVE_ACCOUNT_CHALLENGE,
								response: { challengeId: payload.challengeId },
							})

							ToastService.showSuccess('Challenge deleted')
							return true
						}
						return false
					}
				)
			}
		})
	}
}

const deleteAuthChallenge = (payload: { challengeId: string }) => {
	return async (dispatch: any) => {
		await ConfirmService.confirm({
			title: 'Are you sure you want to delete this challenge?',
		}).then((result) => {
			if (result.value) {
				return ChallengeService.deleteChallenge(payload.challengeId).then(
					(response) => {
						if (response) {
							dispatch({
								type: REMOVE_AUTH_CHALLENGE,
								response: { challengeId: payload.challengeId },
							})

							ToastService.showSuccess('Challenge deleted')
							return true
						}
						return false
					}
				)
			}
		})
	}
}

const setAccountChallenges = (payload: object, filter: boolean = false) => {
	return async (dispatch: any) => {
		await ChallengeService.getChallenges(payload)
			.then((response) => {
				if (!filter) {
					dispatch({
						type: SET_ACCOUNT_CHALLENGES,
						response: response,
					})
					return
				}
				dispatch({
					type: FILTER_ACCOUNT_CHALLENGES,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

const setChallengeSpaceChallenges = (payload: object) => {
	return async (dispatch: any) => {
		await ChallengeService.getChallenges(payload)
			.then((response) => {
				dispatch({
					type: SET_CHALLENGE_SPACE_CHALLENGES,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

const updateChallengeSpaceChallenges = (payload: object) => {
	return async (dispatch: any) => {
		await ChallengeService.getChallenges(payload)
			.then((response) => {
				dispatch({
					type: UPDATE_CHALLENGE_SPACE_CHALLENGES,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

const setChallengeTeams = (challengeId: string) => {
	return async (dispatch: any) => {
		await ChallengeService.getChallengeTeams(challengeId).then((response) => {
			dispatch({
				type: SET_CHALLENGE_TEAMS,
				response: response,
			})
		})
	}
}

const setChallengeUsers = (challengeId: string, params: any) => {
	return async (dispatch: any) => {
		await ChallengeService.updateChallengeUsers(challengeId, params).then(
			(response) => {
				dispatch({
					type: UPDATE_CHALLENGE_SPACE_CHALLENGE_USERS,
					response: response,
					challengeId: challengeId,
				})
			}
		)
	}
}

const updateChallengeTeams = (challengeId: string, params: any) => {
	return async (dispatch: any) => {
		await ChallengeService.updateChallengeTeams(challengeId, params)
			.then((response) => {
				dispatch({
					type: UPDATE_CHALLENGE_TEAMS,
					response: response,
				})

				ToastService.showSuccess(`Challenge team(s) opgeslagen`)
			})
			.catch((error) => {
				ToastService.showError(error.errors.title)
				console.log(error)
			})
	}
}

const setChallenge = (challengeId: string, params) => {
	return async (dispatch: any) => {
		await ChallengeService.getChallenge(challengeId, params).then(
			(response) => {
				dispatch({
					type: SET_ACCOUNT_CHALLENGE,
					response: response,
				})
			}
		)
	}
}

const updateAccountChallenge = (challengeId: string, params: any) => {
	return async (dispatch: any) => {
		await ChallengeService.updateChallenge(challengeId, params)
			.then((response) => {
				dispatch({
					type: UPDATE_ACCOUNT_CHALLENGE,
					response: response,
					challengeId: challengeId,
				})

				ToastService.showSuccess(`Challenge has been saved`)
			})
			.catch((error) => {
				ToastService.showError(`Opslaan mislukt`)
				console.log(error)
			})
	}
}

const updateAccountChallengeUsers = (challengeId: string, params: any) => {
	return async (dispatch: any) => {
		await ChallengeService.updateChallengeUsers(challengeId, params)
			.then((response) => {
				dispatch({
					type: UPDATE_ACCOUNT_CHALLENGE_USERS,
					response: response,
					challengeId: challengeId,
				})
				// also update selectedChallenge (for management section)
				dispatch({
					type: UPDATE_SELECTED_CHALLENGE_USERS,
					response: response,
					challengeId: challengeId,
				})
			})
			.catch((error) => {
				ToastService.showError(`Saving contact persons failed`)
				console.log(error)
			})
	}
}

const updateChallenge = (challengeId: string, params: any) => {
	return async (dispatch: any) => {
		return await ChallengeService.updateChallenge(challengeId, params)
			.then((response) => {
				dispatch({
					type: UPDATE_CHALLENGE_SPACE_CHALLENGE,
					response: response,
					challengeId: challengeId,
				})

				return ToastService.showSuccess(`Challenge has been saved`)
			})
			.catch((error) => {
				console.log(error)
				return ToastService.showError(`Opslaan mislukt`)
			})
	}
}

const updateChallengeState = (payload: {
	challengeId: string
	state: 0 | 1 | 2
	message?: string
}) => {
	let type

	switch (payload.state) {
		case 1:
			type = 'approve'
			break
		case 2:
			type = 'set-pending'
			break
		case 0:
			type = 'unapprove'
			break
	}

	if (type === 'unapprove') {
		return async () => {
			return await ChallengeService.updateChallengeState(payload.challengeId, {
				state: 0,
				message: payload.message ? payload.message : null,
			}).then((response) => {
				if (response.errors) {
					throw new Error(response.errors)
				}
				ToastService.showSuccess(`Challenge unapproved`)
				return response
			})
		}
	}

	return async () => {
		let alertConfig = {
			title:
				type === 'set-pending'
					? `Are you sure you want to set this challenge to pending approval?`
					: `Are you sure you want to ${type} this challenge?`,
		}

		if (type === 'approve') {
			alertConfig[
				'text'
			] = `The contact person(s) will receive an email that the challenge is approved`
		}

		return ConfirmService.confirm(alertConfig).then((result) => {
			if (result.isConfirmed) {
				return ChallengeService.updateChallengeState(payload.challengeId, {
					state: payload.state,
					message: result.value ? result.value : null,
				}).then((response) => {
					if (response.errors) {
						throw new Error(response.errors)
					}

					if (type === 'set-pending') {
						ToastService.showSuccess(`Challenge set to pending approval`)
					} else {
						ToastService.showSuccess(`Challenge ${type}d`)
					}

					return response
				})
			}
		})
	}
}

const setChallengeNote = (challengeId) => {
	return async (dispatch: any) => {
		await ChallengeService.getChallengeNote(challengeId).then((response) => {
			dispatch({
				type: SET_ACCOUNT_CHALLENGE_NOTE,
				response: response,
			})
		})
	}
}

const updateChallengeNote = (challengeId, params) => {
	return async (dispatch: any) => {
		await ChallengeService.updateChallengeNote(challengeId, params).then(
			(response) => {
				dispatch({
					type: SET_ACCOUNT_CHALLENGE_NOTE,
					response: response,
				})
			}
		)
	}
}

export {
	createChallenge,
	setChallengeSpaceChallenges,
	updateChallengeSpaceChallenges,
	setAccountChallenges,
	updateChallengeState,
	setChallenge,
	deleteChallenge,
	updateChallenge,
	updateAccountChallenge,
	updateAccountChallengeUsers,
	deleteAccountChallenge,
	deleteAuthChallenge,
	setChallengeTeams,
	updateChallengeTeams,
	setChallengeUsers,
	setChallengeNote,
	updateChallengeNote,
}
